import { useMutation } from '@apollo/react-hooks';
import {
  ChangeBusinessStatus,
  ChangeBusinessStatusVariables,
} from '../../graphql/business/types/ChangeBusinessStatus';
import { CHANGE_BUSINESS_STATUS } from '../../graphql/business/mutation';

export const useChangeBusinessStatus = () => {
  return useMutation<ChangeBusinessStatus, ChangeBusinessStatusVariables>(
    CHANGE_BUSINESS_STATUS,
  );
};

